import styled, { css } from 'styled-components';
import palette from '../../../lib/styles/palette';

/* Multi Input 컴포넌트 */
export const LoadNoLoadLabel = ({
    label,
    variable,
    variableName,
    unit,
    min = '0',
    referenceValues,
    onChange,
    isRequired,
    isText = false,
    ...props
}) => {
    const indexMap = {
        0: '1st',
        1: '2nd',
        2: '3rd',
    };
    const values = ['Load', 'No Load']
    return (
        <Wrapper>
            <Label>{}</Label>
            <Variable>{variable}</Variable>
            <InputBlock>
                {values.map((value, index) => (
                    <StyledInput
                        key={index}
                        name={`${indexMap[index]}_${variableName}`}
                        value={value}
                        onChange={(e) => {
                            if (isText) {
                                onChange(e);
                            } else {
                                const newValue = e.target.value;
                                // 숫자가 아니거나 'min'보다 작으면 실행하지 않음
                                if (newValue === '' || Number(newValue) >= Number(min)) {
                                    onChange(e);
                                }
                            }
                        }}
                        placeholder={referenceValues?.[index] ?? ''}
                        {...props}
                    />
                ))}
            </InputBlock>
            <Unit>{unit}</Unit>
        </Wrapper>
    );
};


/* ----------------  Styled Components ----------------- */
const Wrapper = styled.div`
    width: 100%;
    display: flex;
    align-items: center;
    padding: 0.25rem 1rem;
    transition: background-color 0.3s ease;
    border-radius: 5px;
    &:hover {
        background-color: ${palette.gray[1]};
    }
`;

const Label = styled.div`
    flex: 1;
    overflow: hidden;
`;

const Variable = styled.div`
    margin-right: 1rem;
    text-align: right;
    font-size: 0.9rem;
    color: ${palette.gray[6]};
`;

const InputBlock = styled.div`
    display: flex;
    gap: 1rem;
`;

const StyledInput = styled.input`
    width: 100px;
    // box-sizing: boder-box;
    border: none;
    border-bottom: 1px solid ${palette.gray[6]};
    outline: none;
    background-color: transparent;
    text-align: center;
    padding: 0.25rem 0;
    padding-right: 0.5rem;
    font-size: 0.95rem;

    &::placeholder {
        color: ${palette.lime[5]};
        font-style: italic;
    }

    ${(props) =>
        props.isRequired &&
        css`
            background-color: ${palette.yachtBlue};
            color: white;
        `}
`;

// const StyledOutput = styled(StyledInput)`
//     background-color: transparent;
// `;

// const StyledSelect = styled.select`
//     width: 100px;
//     border: none;
//     outline: none;
//     background-color: ${palette.cyan[0]};
//     text-align: center;
//     padding: 0.25rem 0;
// `;

const Unit = styled.div`
    width: 60px;
    margin-left: 1rem;
    overflow: hidden;
    font-size: 0.9rem;
    color: ${palette.gray[6]};
`;
